<div class="container px-4 py-5 my-5 text-center bg-white rounded-4">
  <h1 class="display-5 fw-bold text-body-emphasis">Dorpelbestellen.nl</h1>
  <div class="col-lg-6 text-center mx-auto">
    <p class="mb-4"> Dit portaal is ingericht voor bestaande klanten van <a
        href="https://www.luvema.nl" target="_blank"><b>Luvema</b></a>.<br><br>Bent u nog geen klant of heeft u vragen neem dan <a
        href="https://www.luvema.nl/contact/" target="_blank"><b>contact</b></a> met ons op.<br><br>
      Wilt u alleen profielen bestellen? Dat kan op <a [href]="crossPortalLink"
        target="_blank"><b>profielbestellen.nl</b></a>
    </p>
  </div>
</div>

<div class="container px-4 py-5 my-5 bg-white rounded-4">
  <h4 class="mb-3">Accountgegevens</h4>
  <div class="row g-3" [formGroup]="formGroup" *ngIf="formGroup" id="panel1">
    <div class="col-md-6">
      <label for="dealerCode" class="form-label">Dealer</label>
      <select class="form-select" id="dealerCode" formControlName="dealerCode" (change)="onDealerChanged()">
        <option value="" disabled selected hidden>Selecteer een waarde a.u.b.</option>
        <ng-container *ngFor="let dealer of dealers">
          <option value="{{dealer.dealerCode}}">{{dealer.naam}}</option>
        </ng-container>
      </select>
      <luv-validationError [show]="showError('dealerCode')" [errorMessage]="errorMessage('dealerCode')">
      </luv-validationError>
    </div>

    <div class="col-sm-6">
      <label for="contactpersoon" class="form-label">Contactpersoon</label>
      <input type="text" class="form-control" id="contactpersoon" formControlName="contactpersoon">
      <luv-validationError [show]="showError('contactpersoon')" [errorMessage]="errorMessage('contactpersoon')">
      </luv-validationError>
    </div>

    <div class="col-sm-6">
      <label for="emailadres" class="form-label">Email</label>
      <input type="email" class="form-control" id="emailadres" formControlName="emailadres">
      <luv-validationError [show]="showError('emailadres')" [errorMessage]="errorMessage('emailadres')">
      </luv-validationError>
    </div>

    <div class="col-sm-6">
      <label for="telefoonnummer" class="form-label">Telefoonnummer <span
          class="text-body-secondary">(Optioneel)</span></label>
      <input type="Text" class="form-control" id="telefoonnummer" formControlName="telefoonnummer">
      <luv-validationError [show]="showError('telefoonnummer')" [errorMessage]="errorMessage('telefoonnummer')">
      </luv-validationError>
    </div>

    <hr class="my-4">

    <div class="col-sm-4">
      <label for="opdrachtgever" class="form-label">Opdrachtgever <span
          class="text-body-secondary">(Optioneel)</span></label>
      <input type="text" class="form-control" id="opdrachtgever" formControlName="opdrachtgever">
      <luv-validationError [show]="showError('opdrachtgever')" [errorMessage]="errorMessage('opdrachtgever')">
      </luv-validationError>
    </div>


    <div class="col-sm-4">
      <label for="referentie" class="form-label">Uw referentie <span
          class="text-body-secondary">(Optioneel)</span></label>
      <input type="text" class="form-control" id="referentie" formControlName="uwReferentie" />
    </div>

    <div class="col-sm-4">
      <label for="afleverdatum" class="form-label">Gewenste afleveratum <span
          class="text-body-secondary">(Optioneel)</span></label>
      <input class="form-control" type="date" id="afleverdatum" formControlName="afleverdatum"
        min="{{minDeliveryDate}}" />
    </div>

    <hr class="my-4">

    <div class="col-sm-12" formArrayName="bijlage">
      <label for="formFile" class="form-label">Bijlagen</label>

      <div class="row file-row" *ngFor="let fileControl of bijlage.controls; index as idx">
        <div class="col-sm-10">
          <div class="input-group">
            <input acceptedFormats type="file" class="custom-file-input form-control" id="file{{idx}}"
              (change)="onFileSelect($event, idx)" [formControlName]="idx" accept=".pdf,.doc,.docx,.txt">
            <!-- <label for="file{{idx}}" class="custom-file-label">{{model.files[idx]?.name || 'er
              is nog geen bijlage geselecteerd'}}</label> -->
            <span class="input-group-text">bijlage <span *ngIf="bijlage.controls.length > 1">&nbsp;{{idx +
                1}}</span></span>
          </div>
        </div>

        <div class="col-sm-2">
          <button type="button" class="btn btn-danger btn-lg remove-file" (click)="deleteFile(idx)">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
        <div class="col-sm-12">
          <luv-validationError [show]="showError('bijlage', idx)"
            [errorMessage]="errorMessage('bijlage', idx)"></luv-validationError>
        </div>
      </div>

      <div class="col-sm-12">
        <button type="button" class="btn btn-primary" (click)="addFileUploadControl()">+ bijlage</button>
      </div>
    </div>

    <div class="col-sm-12">
      <label for="opmerkingen" class="form-label">Opmerkingen</label>
      <textarea class="form-control" id="opmerkingen" rows="3" formControlName="opmerkingen"></textarea>
    </div>

    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
      <button type="button" class="action-button btn btn-primary btn-lg px-4 gap-3 border-0 rounded-0"
        (click)="onDorpelAddButtonClicked()" [disabled]="isFromPrefilledOrder"><b>Dorpel toevoegen</b></button>
    </div>
  </div>
</div>

<div class="container px-4 py-5 my-5 bg-white rounded-4">
  <h4 class="mb-3">Dorpeloverzicht</h4>

  <table class="table table-striped">
    <ng-container *ngFor="let dorpel of cartItems">
      <tr>
        <td>
          <div><span *ngIf="dorpel.merk">{{dorpel.merk}} - </span>{{dorpel.dorpelCode}} - {{dorpel.zaagmaat}}mm</div>
          <div *ngIf="!dorpel.isInHouseDorpel">This dorpel is not an inhouse dorpel - it will not be processed</div>
        </td>
        <td>
          <div class="no-margin input-group mb-3">
            <input type="number" class="form-control" aria-describedby="aantal" [(ngModel)]="dorpel.aantal" integerOnly />
            <span class="input-group-text" id="aantal">Stuks</span>
          </div>
        </td>
        <td>
          <span class="action-area" (click)="onEditDorpel(dorpel)"><i class="fas fa-pencil-alt"></i></span>
          <span class="action-area" (click)="onDeleteDorpel(dorpel)"><i class="far fa-trash-alt"></i></span>
        </td>
      </tr>
    </ng-container>
  </table>

  <div class="text-center no-content-error">
    <luv-validationError [show]="cartItems.length < 1 && !!posted"
      errorMessage="Voeg s.v.p. eerst een dorpel toe aan de dorpeloverzicht.">
    </luv-validationError>
  </div>

  <div class="row">
    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
      <button type="button" class="action-button btn btn-primary btn-lg px-4 gap-3 border-0 rounded-0"
        (click)="onDorpelBestellenButtonClicked()"><b>Dorpelbestellen</b>
      </button>
    </div>
  </div>
</div>

<app-footer></app-footer>